<template>
    <div class="bg-light p-3 mt-3 sidebar-sub-container" id="milage">
        <h3 class="sidebar-sub-container-headline">Dein Kilometerpaket
            <span class="sidebar-edit-vehicle"
                  data-toggle="modal"
                  data-target="#mileageModal"
                  id="checkout_sidebar_mileage_modal_trigger"
                  dusk="checkout_sidebar_mileage_modal_trigger"
            >
                <i class="far fa-pencil-alt"></i>
            </span>
        </h3>
        <p class="sidebar-sub-container-body mb-2">
            {{ mileage.mileage }} km / Monat <br>
        </p>
        <ul class="li-checkmark">
            <li><i class="fal fa-check text-success"></i> Während der Laufzeit wechselbar</li>
        </ul>

        <!-- Modal -->
        <div class="modal fade" id="mileageModal" tabindex="-1" role="dialog" aria-labelledby="ModalLabel"
             aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">

                    <div class="modal-header">
                        <h5 class="modal-title" id="ModalLabel">Kilometerpaket ändern</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <div class="modal-body">
                        <!--KILOMETERPAKET-->
                        <div class="checkout-options">
                            <p class="text-left col-8"><i class="fal fa-info-circle"></i>
                                <small>
                                    Du kannst das Kilometerpaket während der Laufzeit flexibler wechseln.
                                </small>
                            </p>

                            <span v-for="(option, index) in mileageOptions"
                                  class="option d-block d-md-inline mb-3 mb-md-0">
                                <input type="radio" name="mileage" :value="option.id" :id="option.id + '-radio'"
                                       v-model="selected">
                                <label :for="option.id + '-radio'"> {{ option.value }} km monatlich ({{ (option.value*12) }}
                                    km im Jahr)</label>
                                <br>
                            </span>

                            <h3 class="sidebar-sub-container-headline mt-5"> Dein All-inclusive-Preis beträgt</h3>
                            <h5 class="sidebar-sub-container-headline"><span v-if="ready">{{ price }}</span> € / Monat
                            </h5>

                        </div>
                        <div class="row">
                            <button type="button" class="btn-light p-2 m-2" data-dismiss="modal"><strong>Abbrechen
                                ohne Änderung</strong>
                            </button>
                            <button type="button" @click="updateMileage" class="btn-primary p-2 m-2"><strong>Änderung
                                übernehmen</strong>
                            </button>
                        </div>
                    </div>

                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import PNotify from 'pnotify/dist/es/PNotify';
    import PNotifyStyleMaterial from 'pnotify/dist/es/PNotifyStyleMaterial.js';

    PNotify.defaults.styling = 'bootstrap4';
    PNotify.defaults.icons = 'fontawesome5';

    export default {
        name: "MileAge",
        props: ['vehicle', 'subscription', 'mileageOptions', 'currentMileage', 'currentDuration'],
        data() {
            return {
                selected: 0,
                ready: false
            };
        },
        methods: {
            updateMileage() {
                axios.patch('/api/checkout/' + this.subscription.id, {
                    identifier: this.subscription.identifier,
                    subscription: {
                        price: this.price.replace(',', '.'),
                        mileage_id: this.selected
                    }
                }).then(r => {
                    PNotify.success(r.data.message);
                    this.$emit('mileage-updated');
                    $('#mileageModal').modal('hide');
                }).catch(e => {
                    PNotify.alert("Leider ist ein Fehler aufgetreten. Versuche es später erneut oder wende dich an unseren Support!");
                })
            },
            getVehiclePrices() {
                return this.vehicle.price_calculations;
            },
        },
        computed: {
            price() {
                let prices = this.getVehiclePrices();
                let mileage = this.mileageOptions.find(option => {
                    return option.id === this.selected;
                });
                return prices.brutto[this.currentDuration.months][mileage.tag].toFixed(2).replace('.', ',');
            },
            mileage() {
                return this.subscription.mileage;
            }
        },
        mounted() {
            this.selected = this.mileage.id;
            this.ready = true;
        }
    }
</script>

<style scoped lang="scss">
    #checkout_sidebar_mileage_modal_trigger {
        cursor: pointer;
    }
</style>
